import { frequencyOptions } from '../Component/Recurring/SearchPayments'
import { PaymentResults, RecurringPaymentResponse } from '../Component/Recurring/types'

const mapPaymentResults = (
  data: RecurringPaymentResponse[]
): PaymentResults[] => {
  return data.map((payment) => {
    return {
      id: payment.recurring_id,
      customerName: payment.customer_billing_name,
      nextDate: payment.next_processing_date,
      frequency:
      frequencyOptions.find((option) => option.val === payment.frequency)
        ?.name || '',
      currentCount: parseInt(payment.current_count, 10),
      totalCount: parseInt(payment.total_count, 10),
      amount: payment.amount,
      receipt: payment.customer_receipt,
      customerId: payment.customer_id,
      disabled: false, // Assuming 'disabled' is not part of the type and defaulting to false
      description: payment.description,
      addSurcharge: payment.add_surcharge,
    }
  })
}

export default mapPaymentResults
